(() => {
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => {
      target.parentElement.style.setProperty('--holiday-badge-width', `${target.offsetWidth}px`);
    });
  });

  const observeBadges = (root) => {
    root.querySelectorAll('.card__badge').forEach((badge) => {
      if (badge.querySelector('.holiday-badge')) observer.observe(badge);
    });
  };

  observeBadges(document);
  document.addEventListener('shopify:section:load', (event) => observeBadges(event.target));
})();
